import "./navbar.css";
import LanguageDropdown from "../../components/dropdowns/LanguageDropdown";
import Menubar from "../menubar/menubar";
import ThemeToggle from "../../components/themeToggle/themeToggle";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-row">
        <div className="navbar-branding">
          <div className="navbar-logo">
            <img
              src={"/assets/logo/logobgwhite.png"}
              alt="Company Logo"
              className="circular-logo"
            />
          </div>
          <div className="navbar-logo-name">
            <div><span className="pink-i">PANDEY</span></div>
            <div><span className="pink-i">ART HOUSE</span></div>
          </div>
        </div>

        <div className="navbar-menu-section">
          <Menubar />
        </div>

        <div className="navbar-controls">
          <LanguageDropdown />
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;